
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2500_36527)"}},[_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"32","height":"32"}},[_c('path',{attrs:{"d":"M32 0H0v32h32V0z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M17.76 7.49h-3.518v17.02h3.517V7.49z","fill":"#fff"}}),_c('path',{attrs:{"d":"M24.51 17.76v-3.518H7.487v3.517H24.51z","fill":"#fff"}}),_c('path',{attrs:{"d":"M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0c8.823 0 16 7.177 16 16s-7.177 16-16 16zm0-29.738C8.425 2.262 2.262 8.425 2.262 16c0 7.575 6.163 13.738 13.738 13.738 7.576 0 13.74-6.163 13.74-13.738 0-7.575-6.164-13.738-13.74-13.738z","fill":"#FBBB48"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2500_36527"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    